import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";

const HeroSection = () => {
  return (
    <section className="min-h-screen flex items-center justify-center relative bg-black overflow-hidden">
      {/* Hero Background */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src="/assets/images/home/bg_video.mp4"
          autoPlay
          muted
          loop
          playsInline
        />
      </div>

      <div className="container-wide relative z-10 pt-32 pb-24">
        <div className="max-w-7xl mx-auto text-center flex flex-col items-center">
          {/* Main Headline */}
          <div className="mb-6 !overflow-visible">
            <Reveal trigger="onLoad" delay={0.3} className="inline-block pb-1 !overflow-visible">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light tracking-tighter leading-none text-white">
                Are you Solving
              </h1>
            </Reveal>
            <br />
            <Reveal trigger="onLoad" delay={0.4} className="inline-block pb-2 !overflow-visible">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tighter leading-none text-white">
                <span className="font-light">the</span> <span className="text-white relative inline-block">
                  Wrong Problems
                  <svg
                    className="absolute -bottom-2 left-0 w-full h-3"
                    viewBox="0 0 100 12"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M3,10 Q50,2 97,10"
                      fill="none"
                      stroke="#c0ff09"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </h1>
            </Reveal>
            <br />
            <Reveal trigger="onLoad" delay={0.5} className="inline-block pb-1 !overflow-visible">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light tracking-tighter leading-none text-white">
                in Your Brand?
              </h1>
            </Reveal>
          </div>

          {/* Subheadline */}
          <Reveal trigger="onLoad" delay={0.8} className="max-w-xl mx-auto mb-8">
            <p className="text-xs sm:text-sm md:text-base text-white/70 leading-relaxed font-light">
              In a market of sameness, standing out is not just about aesthetics. It is about clarity, direction, and positioning that makes your brand unmissable and unavoidable.
            </p>
          </Reveal>

          {/* CTAs */}
          <Reveal trigger="onLoad" delay={1.0}>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Button variant="outline" className="rounded-full px-8 py-4 h-auto text-lg hover:bg-[#c0ff09] hover:text-black transition-colors" asChild>
                <Link to="/projects">
                  See Our Works
                </Link>
              </Button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
